<style scoped lang="scss">
.sds-notif{
  box-shadow: rgba(149, 157, 165, 0.2) 0px 8px 24px;
  margin-bottom: 15px;
  padding: 15px 25px;
  display: flex;
  align-items: center;
  font-size: 12px;
  line-height: 1.2;

  &.warning{
    background:#fffde7;
    border: 1px solid #eebe2e !important;
  }
  &.success{
    background:#e7fffe;
    border: 1px solid #00a191 !important;
  }
}
#create-ms-ind{
  font-family: 'Manrope';
  background: #f9f9f9;
  min-height: calc(100vh - 45px);
}

.questionnaire{
  min-height: 67vh;
  display: flex;
  flex-direction: column;
  border:1px solid #b8b8b8;
  position: relative;
  background:white;
  box-shadow: rgba(149, 157, 165, 0.2) 0px 8px 24px;

  &-navigation{
    display: flex;
    border-bottom:none;
    border-top:1px solid #e0e0e0;
    // border-bottom:1px solid #e0e0e0;
    background: white;
    padding: 0px 50px 0px 50px;

    & .item{

      font-size: 13px;
      font-weight: 500;
      padding: 5px 15px;
      // margin:-1px;
      border-left:1px solid #e0e0e0;
      &:last-child{
        border-right:1px solid #e0e0e0;
      }
      &.active{
        // color: #2d2d2d;
        color: white;
        font-size: 13px;
        // background: #e5e5e5;
        background: #005f4f;
        border:1px solid #005f4f;
      }
      &.invalid{
        // color: #2d2d2d;
        color: white;
        font-size: 13px;
        // background: #e5e5e5;
        background: #dc3545;
        border-color: rgb(255, 214, 214);
      }
      &.status{
        font-weight: 600;
        background: white;
        margin-left: auto;
        border:none;
        font-size: 12px;
        padding-right:0 ;
        & div{
          border-radius:5px ;
          padding: 1px 3px;
        }
        & .draft{
          background-color: #cccccc;
          color: #424242;
          border: 1px solid #cccccc;
        }
        
        & .submitted{
          color: #1976D2;
          background: #E3F2FD;
          border: 1px solid #90CAF9;
          
          &.darker{
            background: #006aff;
            color: white;
          }
        }
        & .under-review{
          color: #7b6400;
          background: #ffe600;
          border: 1px solid #d8c300;
        }
        & .correction-required, &.revised{
          color: #7B1FA2;
          background: #F3E5F5;
          border: 1px solid #CE93D8;
          
        }
        & .rejected{
          background: rgb(253, 208, 208);
          color: rgb(201, 0, 0);
          border: 1px solid rgb(255, 143, 143);
        }
        & .approved{
          font-weight: 600;
          background: #c4ffc4;
          color: rgb(22, 139, 22);
          border: 1px solid rgb(97, 213, 97);
        }
        & .published{
          font-weight: 500;
          background: rgb(192, 255, 192);
          color: rgb(25, 136, 25);
          border: 1px solid rgb(154, 234, 154);
        }

      }
      
    }
    

    & .button-navigation{
      & .prev{
        padding: 5px 15px;
      }
      & .next{
        padding: 5px 15px;
        background: teal;
        color: white;
      }
      
    }
  }
  &.entry-mode{
    & .blok-detail {
      padding: 20px 25px;

      & .question{
        border:none !important;
      }
      
    }
  }
  & .blok{
    & .blok-title {
      color: #2d2d2d;
      font-size: 14px;
      font-weight: 700;
      background: #e5e5e5;
      padding: 0.25rem 0.5rem;
      text-align: center;

      border-top:1px solid #b8b8b8;
      border-bottom:1px solid #b8b8b8;
      text-transform: uppercase;
    }
    &:first-child .blok-title{
      border-top: none;
    }
  }
  & .blok-detail {
    padding: 20px 25px;

    & .question{
      padding: 10px 0px;
      &:first-child{
        padding-top: 0;
      }
      &:last-child{
        padding-bottom: 0;
      }
      &:not(:last-child){
        border-bottom: 1px solid rgb(210, 210, 210);
      }
      &__name{
        font-size: 13px;
        font-weight: 700;
        margin-bottom: 0rem;
        color: #212121;
      }
      &__value{
        font-size: 13px;
        font-weight: 500;
        margin-bottom: 0rem;
        color: #525252;

        & input, & .vue-treeselect, & textarea, & div[role="radiogroup"], & ul, & .multiselect{
          margin-top: 3px !important;
        }
        & div[role="radiogroup"]{
          margin-left: 3px !important;
        }
        & .custom-checkbox{
          margin-left: 3px !important;
        }
        & ul{
          margin-left: -35px !important;
        }
      }
      & ul.list{
        list-style-type: none;
        margin-left: -40px;
        margin-bottom: 0;

        & li::before{
          content: '- ';
        }
        & li:only-child::before{
          content: '';
        }
      }
    }

    &  p.question {
      font-size: 13px;
      font-weight: 700;
      margin-bottom: 0rem;
      color: #212121;
    }
    &  p {
      font-size: 13px;
      font-weight: 500;
      margin-bottom: 0rem;
      color: #525252;
    }
    
  }
  &__status{
		margin-top: -7px;
    margin-left: 4px;
		padding:3px 5px;
    letter-spacing: .3px;
    font-size: 12px;
		border-radius: 5px 0px 5px 0px;
		display: flex;
		align-items: center;
		justify-content: center;
		font-weight: 600;
		color: rgb(251, 229, 229);
		border: 1px solid #cccccc;
		background-color: #cccccc;
		color: #424242;

    &2{
      border-radius: 0px 0px 0px 15px;
      position: absolute;
      top:-1px;
      right:-1px;
      padding:5px 10px;
    }
    &3{
      margin-top: 0px;
      margin-left: 0px;
      font-weight: 600;
      padding:3px 5px;
    }
		&.draft, &2.draft , &3.draft{
      color: #424242;
      background: #cccccc;
      border: 1px solid #bbbbbb;
    }
		&.submitted, &2.submitted, &3.submitted{
      color: #1976D2;
      background: #E3F2FD;
      border: 1px solid #90CAF9;
      
      &.darker{
        background: #006aff;
        color: white;
      }
    }
    &.under-review, &2.under-review, &3.under-review{
      font-weight: 600;
      color: #8c7200;
      background: #fff27d;
      border: 1px solid #dfcd2b;
    }
    &.correction-required, &.revised, &2.correction-required, &2.revised, &3.correction-required, &3.revised{
      color: #7B1FA2;
      background: #F3E5F5;
      border: 1px solid #CE93D8;
      
    }
    &.rejected, &2.rejected, &3.rejected{
      background: rgb(253, 208, 208);
      color: rgb(201, 0, 0);
      border: 1px solid rgb(255, 143, 143);
    }
    &.approved, &2.approved, &3.approved{
      font-weight: 600;
      background: #c4ffc4;
      color: rgb(22, 139, 22);
      border: 1px solid rgb(97, 213, 97);
    }
    &.published, &2.published, &3.published{
      font-weight: 500;
      background: rgb(192, 255, 192);
      color: rgb(25, 136, 25);
      border: 1px solid rgb(154, 234, 154);
    }

	}
  &__body{
    flex-direction: column;
    display: flex;
    flex-grow: 1;
  }
  &__footer{
    border-top:1px solid #b8b8b8;
    bottom:0;
    display: flex;
    padding: 10px 20px;
  }
  
}


/* ============================================================
   History Status (ms_keg_histories)
   ============================================================ */
.history-status {
  margin-top: 12px;

  &__item {
    padding: 8px 10px;
    margin-bottom: 8px;
    border-left: 3px solid #e0e0e0;
    background: #fafafa;
    border-radius: 4px;
  }

  &__number {
    font-size: 11px;
    font-weight: 600;
    color: #424242;
    min-width: 18px;
  }

  &__badge {
    display: inline-block;
    padding: 2px 8px;
    border-radius: 10px;
    font-size: 10px;
    font-weight: 700;
    letter-spacing: .3px;
    border: 1px solid transparent;

    &--draft {
      color: #424242;
      background: #cccccc;
      border-color: #bbbbbb;
    }
    &--submitted {
      color: #1976D2;
      background: #E3F2FD;
      border-color: #90CAF9;
    }
    &--under-review {
      font-weight: 600;
      color: #8c7200;
      background: #fff27d;
      border-color: #dfcd2b;
    }
    &--correction-required,
    &--revised {
      color: #7B1FA2;
      background: #F3E5F5;
      border-color: #CE93D8;
    }
    &--rejected {
      background: rgb(253, 208, 208);
      color: rgb(201, 0, 0);
      border-color: rgb(255, 143, 143);
    }
    &--approved {
      font-weight: 600;
      background: #c4ffc4;
      color: rgb(22, 139, 22);
      border-color: rgb(97, 213, 97);
    }
    &--published {
      font-weight: 500;
      background: rgb(192, 255, 192);
      color: rgb(25, 136, 25);
      border-color: rgb(154, 234, 154);
    }
  }

  &__info {
    font-size: 10px;
    color: #757575;
    margin-top: 4px;
    margin-left: 18px;
    font-style: italic;
  }

  &__rejection {
    font-size: 11px;
    color: #c9302c;
    margin-top: 4px;
    margin-left: 18px;
    padding: 4px 6px;
    background: #fff5f5;
    border-radius: 3px;
    border: 1px solid #f5c6cb;
  }
}
</style>
<template>
  <div id="create-ms-ind">
    <div class="page-control--secondary" >
      <div class="page-control__body">
        <div class="page-control__left">
          <button class="button button--text button--action mr-2"  id="backUsulanList" @click="$router.back()">
              <VueFeather type="arrow-left" size="18" stroke-width="1.5" style="display:block"></VueFeather>
          </button>
          <b-popover target="backUsulanList" triggers="hover" placement="bottom">
            <template #title>Kembali ke halaman daftar usulan</template>
            Pastikan anda sudah menyimpan isian terlebih dahulu dengan klik tombol draft atau submit, karena ketika kembali isian ada akan hilang
          </b-popover>
          <div class="my-1">
            <div class="d-flex align-items-start" style="font-family:'Manrope';font-weight:600;font-size:16px;color:#032F05;line-height:1">
              
              <div v-if="route  == 'AddMsVar'">
                Lapor<span class="text-primary" > Metadata Variabel </span>Baru
              </div>
              <div v-else-if="route  == 'UpdateMsVar'">
                Update Metadata Variabel <span class="text-primary" >{{data.nama}}</span> 
              </div>
              <div v-else>
                Detail Metadata Variabel <span class="text-primary" >{{data.nama}}</span> 
              </div>
            </div>
            <div class="" style="font-family:'Manrope';font-weight:500;font-size:12px;color:#515151;">
              Harap baca panduan terlebih dahulu, agar pelaporan Anda dapat menjadi lebih mudah.
            </div>
            
          </div>
        </div>
        <div class="page-control__center">
        </div>
        <div class="page-control__right align-items-center">
          <div v-if="route != 'ViewMsVar' && route != 'ApproveMsVar'" class="d-flex align-items-center" style="margin:5px 0px 5px 5px">
            <button 
              v-if="route == 'UpdateMsVar'"
              class="button mr-2" 
              :variant="isReviewOpen ? 'primary' : 'outlined'" 
              size="sm" 
              @click="isReviewOpen = !isReviewOpen"
              title="Tampilkan / Sembunyikan Panel Catatan & Histori"
            >
              <VueFeather type="mail" size="14" stroke-width="2" style="display:block;"></VueFeather>&nbsp;&nbsp;Catatan Pemeriksaan
              <span v-if="(form.reviews && form.reviews.length > 0) || (reviewHistories && reviewHistories.length > 0)" class="badge badge-light ml-1 text-primary">
                {{ (form.reviews ? form.reviews.length : 0) + (reviewHistories ? reviewHistories.length : 0) }}
              </span>
            </button>
            <div class="tags">
            <div :class="'mr-1 tag tag--status '+statusFormatterStyle(form.status)">
              <div class="tag__field">Status</div>
              <div class="tag__value">{{statusFormatter(form.status)}}</div>
            </div>
          </div>
          
          <div class="w-5" style="border-right:1px solid #e4e4e4; height:35px;"></div>
            <button  class="button mx-2" variant="outlined" size="sm" @click="save('DRAFT')">
              <VueFeather type="check" size="15" stroke-width="2.5" style="display:block;"></VueFeather>&nbsp;&nbsp;Simpan Sementara
            </button>
            <button  class="button" variant="primary" size="sm" @click="save('SUBMITTED')">
              <VueFeather type="send" size="14" stroke-width="2" style="display:block;"></VueFeather>&nbsp;&nbsp;Submit
            </button>
          </div>

          <div v-if="route == 'ApproveMsVar'" class="page-control__right align-items-center">
            <button class="button" variant="primary" size="sm" @click="()=>{$bvModal.show('modal-approval')}">
              <VueFeather type="send" size="14" stroke-width="2" style="display:block;"></VueFeather>&nbsp;&nbsp;Simpan
            </button>
          </div>
        </div>
      </div>
    </div>

    <div class="content content--borderless">
      <div v-if="isLoading" class="content__loading">
        <img src="@/assets/icons/loading-plane.gif" width="200" height="200" style="margin-top:-60px"/>
        <div style="margin-top:-60px">
          Sedang mengambil data ke server, harap tunggu sebentar....
        </div> 
      </div>
      <div v-else class="content__body" style="margin: 20px 45px 25px 45px">
        <div class="tags tags--secondary" style="margin-top:-10px; padding-bottom:10px" v-if="msVar">
          <div class="tag tag--secondary "> 
            <div class="tag__field">ID</div>
            <div class="tag__value">{{msVar.id}}</div>
          </div>
          <div class="tag tag--primary">
            <div class="tag__field">Pelapor</div>
            <div class="tag__value">{{msVar.requester_details ? msVar.requester_details.name : msVar.requested_by}}</div>
          </div>
          <div class="tag tag--secondary "> 
            <div class="tag__field">Tanggal Usulan</div>
            <div class="tag__value">{{msVar.created_at | formatDate}}</div>
          </div>
        </div>

        <!-- <div class="sds-notif warning" v-if="showSdsRedirectNotif == true">
          <div class="mr-3" style="">
            <VueFeather type="alert-triangle" size="26" stroke="#ce9b00" fill="#FFF59D" stroke-width="2" style="display:block;"></VueFeather>
          </div>
          <div >
            <div class="text-13 text-semi-bold " style="color:#ad8200;margin-bottom:2px">Variabel tidak Standar</div>
            <div style="color:#c29200">Variabel yang dipilih sebaiknya merujuk pada Standar Data Statistik (SDS).
              Silahkan usulkan variabel menjadi SDS baru dengan melakukan klik pada tombol disamping ini
              
            </div>
          </div>
          <b-button class="ml-auto button--warning w-101" to="/old-sds/daftar-usulan">Usul SDS</b-button>
        </div>        
        <div class="sds-notif success" v-if="showSdsRedirectNotif == false || this.data.id_sds">
          <div class="mr-3" style="">
            <VueFeather type="check-circle" size="26" stroke="#00897B" fill="#c6fffd" stroke-width="2" style="display:block;"></VueFeather>
          </div>
          <div >
            <div class="text-13 text-semi-bold " style="color:#00897B;margin-bottom:2px">Variabel Standar</div>
            <div style="color:#009688">
              Variabel sudah merujuk pada Standar Data Statistik (SDS). Lanjut Pengisian MS-Var
            </div>
          </div>
        </div> -->

        <b-row>
          <b-col>
            <div class="questionnaire " :class="route == 'ViewMsVar' || route == 'ApproveMsVar'? '' : 'entry-mode'">
              <div :class="'questionnaire__status2 '+statusFormatterStyle(form.status)" v-if="!['DRAFT','SUBMITTED'].includes(form.status) ">{{statusFormatter(form.status)}}</div>
                  
              <div class="form form--sm questionnaire__body">
                <ValidationObserver ref="blok1Observer">
                  <div class="blok">
                    <div class="blok-detail">
                      <div class="question">
                        <div class="question__name">Nama:</div>
                        <div class="question__value" v-if="route == 'ViewMsVar' || route == 'ApproveMsVar'">{{data.nama}}</div>
                        <div class="question__value" v-else>
                          <ValidationProvider name="Nama Variabel"  v-slot="{errors}">
                            <multiselect 
                              tag-placeholder="Input variabel manual" 
                              placeholder="Pilih variabel dari SDS atau tambahkan variabel secara manual" 
                              selectLabel="" deselectLabel="" selectedLabel="" openDirection="bottom"
                              label="name"  track-by="id" 
                              v-model="sds" 
                              :options="options.sds" 
                              :taggable="true" 
                              :searchable="true"
                              :multiple="false"
                              :allow-empty="true"
                              :loading="isSdsLoading" 
                              :options-limit="300" :limit="3"
                              @search-change="getSdsList"
                              :class="errors[0] ? 'invalid': ( data.nama ? 'valid':'')"
                              @tag="inputVariableManual"
                              @input="useVariableSds"

                              >
                              <template slot="tag" slot-scope="{props}">{{props.search}}</template>
                              <template slot="noOptions">
                                <div class="d-flex align-items-center">
                                  <VueFeather type="alert-circle" size="16" stroke-width="2" style="display:block;" stroke="#E65100"></VueFeather>&nbsp;&nbsp;
                                  <span style="color:#E65100">Ketikkan beberapa kata untuk memulai pencarian</span>
                                </div>
                              </template>
                              <template slot="option" slot-scope="props">
                                <div class="d-flex align-items-center flex-grow-1">
                                  <div >
                                    <div style="white-space:initial">
                                      {{ props.option.name ? props.option.name :props.search}}
                                    </div>
                                    <div class="mt-2 text-11 text-500" v-if="props.option.name != null">
                                      {{props.option.produsen_data_name}}
                                    </div>
                                  </div>
                                  <div v-if="props.option.name != null" :class="'text-nowrap ml-auto status status--'+statusFormatterStyle(props.option.status)">
                                    {{sdsStatusFormatter(props.option.status)}}
                                  </div>
                                </div>
                              </template>
                            </multiselect>
                            <b-form-invalid-feedback :state="false">{{ errors[0] }}</b-form-invalid-feedback>
                          </ValidationProvider>

                          
                        </div>
                      </div>

                      <div class="question">
                        <div class="question__name">Alias:</div>
                        <div class="question__value" v-if="route == 'ViewMsVar' || route == 'ApproveMsVar'">{{data.alias}}</div>
                        <div class="question__value" v-else>
                          <b-form-input 
                            v-model="data.alias" 
                            placeholder="Tuliskan Alias"
                          >
                          </b-form-input>
                        </div>
                      </div>

                      

                      <div class="question">
                        <div class="question__name">Definisi Variabel:</div>
                        <div class="question__value" v-if="route == 'ViewMsVar' || route == 'ApproveMsVar'">{{data.definisi}}</div>
                        <div class="question__value" v-else>
                          <ValidationProvider name="Definisi Variabel"  rules="required" v-slot="{errors}">
                            <b-form-textarea 
                              rows="3"
                              v-model="data.definisi" 
                              placeholder="Tuliskan secara jelas Definisi Variabel" 
                              :state="errors[0] ? false: (data.definisi? true : null)"
                            >
                            </b-form-textarea>
                            <b-form-invalid-feedback :state="false">{{ errors[0] }}</b-form-invalid-feedback>
                          </ValidationProvider>
                        </div>
                      </div>

                      <div class="question">
                        <div class="question__name">Konsep:</div>
                        <div class="question__value" v-if="route == 'ViewMsVar' || route == 'ApproveMsVar'">
                          <div v-for="(item, index) in data.konsep" :key="index" class="d-flex">
                            <div class="w-15" v-if="data.konsep.length>1">{{index+1}}.</div>
                            <div>{{item}}</div>
                          </div>
                          <div v-if="data.konsep.length==0">-</div>
                        </div>
                        <div class="question__value" v-else>
                          <ValidationObserver ref="conceptVariableObserver" v-slot="{ validate }">
                            <div v-for="(item, index) in data.konsep" :key="index" >
                              <ValidationProvider :name="'Konsep ke-'+(index+1)"  rules="required" v-slot="{errors}">
                                <div class="d-flex">
                                  <b-form-input 
                                    v-model="data.konsep[index]" 
                                    placeholder="Tuliskan Konsep yang digunakan"
                                    :state="errors[0] ? false: (data.konsep[index] ? true : null)"
                                  >
                                  </b-form-input>
                                  <b-button v-if="data.id_sds ==null"  class="button button--action button--action--delete2 ml-2" style="margin-top:3px"  @click="data.konsep.splice(index,1)" >
                                    <VueFeather type="x" size="14" stroke-width="2" style="display:block;"></VueFeather>
                                  </b-button>
                                </div>
                                <b-form-invalid-feedback :state="false">{{ errors[0] }}</b-form-invalid-feedback>
                                <div class="d-flex mt-2" v-if="data.id_sds == null && index==data.konsep.length-1">
                                  <div class="flex-grow-1 text-600">
                                    Jika Konsep Lebih dari satu bisa melakukan klik tombol tambah
                                  </div>
                                  <b-button  class="button button--action button--action--view2 " 
                                    @click="()=>{
                                      validate().then(result =>{
                                        if(result){
                                          data.konsep.push(null);
                                        }
                                      })}">
                                    <VueFeather type="plus" size="14" stroke-width="2" style="display:block;"></VueFeather>
                                  </b-button>
                                </div>
                                
                              </ValidationProvider>
                            </div>
                          </ValidationObserver>
                        </div>
                      </div>

                      <div class="question">
                        <div class="question__name">Referensi Pemilihan:</div>
                        <div class="question__value" v-if="route == 'ViewMsVar' || route == 'ApproveMsVar'">
                          <div class="d-flex" v-for="(item, index) in data.referensi_pemilihan" :key="index">
                            <div class="w-20" v-if="data.referensi_pemilihan.length>1">{{index+1}}.</div>
                            <div>{{item}}</div>
                          </div>
                        </div>
                        <div class="question__value" v-else>
                          <ValidationObserver ref="referenceVariableObserver" v-slot="{ validate }">
                            <div v-for="(item, index) in data.referensi_pemilihan" :key="index" >
                              <ValidationProvider :name="'Referensi Pemilihan ke-'+(index+1)"  rules="required" v-slot="{errors}">
                                <div class="d-flex">
                                  <b-form-input 
                                    v-model="data.referensi_pemilihan[index]" 
                                    placeholder="Tulisakan Referensi Pemilihan"
                                    :state="errors[0] ? false: (data.referensi_pemilihan[index] ? true : null)"
                                  >
                                  </b-form-input>
                                  <b-button v-if="data.id_sds == null" class="button button--action button--action--delete2 ml-2" style="margin-top:3px"  @click="data.referensi_pemilihan.splice(index,1)" >
                                    <VueFeather type="x" size="14" stroke-width="2" style="display:block;"></VueFeather>
                                  </b-button>
                                </div>
                                <b-form-invalid-feedback :state="false">{{ errors[0] }}</b-form-invalid-feedback>
                              </ValidationProvider>
                            </div>

                            <div class="d-flex mt-2" v-if="data.id_sds == null">
                              <div class="flex-grow-1 text-600">
                                Jika Referensi Pemilihan Lebih dari satu bisa melakukan klik tombol tambah
                              </div>
                              <b-button  class="button button--action button--action--view2 " 
                                @click="()=>{
                                  validate().then(result =>{
                                    if(result){
                                      data.referensi_pemilihan.push(null);
                                    }
                                  })}">
                                <VueFeather type="plus" size="14" stroke-width="2" style="display:block;"></VueFeather>
                              </b-button>
                            </div>
                          </ValidationObserver>
                        </div>
                      </div>

                      <div class="question">
                        <div class="question__name">Referensi Waktu:</div>
                        <div class="question__value" v-if="route == 'ViewMsVar' || route == 'ApproveMsVar'">{{data.referensi_waktu}}</div>
                        <div class="question__value" v-else>
                          <ValidationProvider name="Referensi Waktu"  rules="required" v-slot="{errors}">
                            <b-form-input 
                              v-model="data.referensi_waktu" 
                              placeholder="Tulisakan Referensi Waktu "
                              :state="errors[0] ? false: (data.referensi_waktu ? true : null)"
                            >
                            </b-form-input>
                            <b-form-invalid-feedback :state="false">{{ errors[0] }}</b-form-invalid-feedback>
                          </ValidationProvider>
                        </div>
                      </div>

                      <div class="question">
                        <div class="question__name">Ukuran:</div>
                        <div class="question__value" v-if="route == 'ViewMsVar' || route == 'ApproveMsVar'">{{data.ukuran}}</div>
                        <div class="question__value" v-else>
                          <b-form-input 
                            v-model="data.ukuran" 
                            placeholder="Tulisakan Ukuran"
                            :state="data.ukuran ? true : null"
                          >
                          </b-form-input>
                        </div>
                      </div>

                      <div class="question">
                        <div class="question__name">Satuan:</div>
                        <div class="question__value" v-if="route == 'ViewMsVar' || route == 'ApproveMsVar'">{{data.satuan}}</div>
                        <div class="question__value" v-else>
                          <ValidationProvider name="Satuan"  :rules="data.id_sds != null && data.ukuran ? 'required' : ''" v-slot="{errors}">
                            <b-form-input 
                              v-model="data.satuan" 
                              placeholder="Tulisakan Satuan "
                              :state="errors[0] ? false: (data.satuan ? true : null)"
                            >
                            </b-form-input>
                            <b-form-invalid-feedback :state="false">{{ errors[0] }}</b-form-invalid-feedback>
                          </ValidationProvider>
                        </div>
                      </div>

                      <div class="question">
                        <div class="question__name">Tipe Data:</div>
                        <div class="question__value" v-if="route == 'ViewMsVar' || route == 'ApproveMsVar'">{{data.tipe_data}}</div>
                        <div class="question__value" v-else>
                          <ValidationProvider name="Tipe Data"  rules="required" v-slot="{errors}">
                            <b-form-input 
                              v-model="data.tipe_data" 
                              placeholder="Tulisakan Tipe Data"
                              :state="errors[0] ? false: (data.tipe_data ? true : null)"
                            >
                            </b-form-input>
                            <b-form-invalid-feedback :state="false">{{ errors[0] }}</b-form-invalid-feedback>
                          </ValidationProvider>
                        </div>
                      </div>

                      
                      <div class="question border-bottom-0">
                        <div class="question__name">Isian Klasifikasi:</div>
                        <div class="question__value">
                          <ValidationObserver ref="valudeDomainVariableObserver" v-slot="{ validate }">
                            <div class="table-wrapper mt-2">
                              <b-table-simple class="table table--light table--bordered">
                                <thead>
                                  <tr>
                                    <th class="w-40">No</th>
                                    <th class="w-200">Kode Item Klasifikasi</th>
                                    <th>Nama Item Klasifikasi</th>
                                    <th class="w-51" v-if="data.id_sds == null && (route != 'ViewMsVar' && route != 'ApproveMsVar')">Aksi</th>
                                  </tr>
                                </thead>
                                <tbody v-if="route == 'ViewMsVar' || route == 'ApproveMsVar'">
                                  <tr v-for="(item, index) in data.value_domain" :key="index">
                                    <td class="text-center">
                                      {{index+1}}  
                                    </td>
                                    <td>{{data.value_domain[index].kode}}</td>
                                    <td>{{data.value_domain[index].nilai}}</td>
                                  </tr>
                                </tbody>
                                <tbody v-else>
                                  <tr v-for="(item, index) in data.value_domain" :key="index">
                                    <td class="text-center">
                                      <b-form-input :value="index+1" disabled style="text-align:center" size="sm"></b-form-input> 
                                    </td>
                                    <td>
                                      <ValidationProvider :name="'Kode Item Klasifikasi ke-'+(index+1)"  :rules="data.id_sds!=null ? '':'required'" v-slot="{errors}">
                                        <b-form-input 
                                          v-model="data.value_domain[index].kode" 
                                          placeholder="Kode item"
                                          :state="errors[0] ? false: (data.value_domain[index].kode? true : null)"
                                        >
                                        </b-form-input>
                                        <b-form-invalid-feedback :state="false">{{ errors[0] }}</b-form-invalid-feedback>
                                      </ValidationProvider>
                                    </td>
                                    <td>
                                      <ValidationProvider :name="'Nama Item Klasifikasi ke-'+(index+1)"  :rules="data.id_sds!=null ? '':'required'" v-slot="{errors}">
                                        <b-form-input 
                                          v-model="data.value_domain[index].nilai" 
                                          placeholder="Nama Item"
                                          :state="errors[0] ? false: (data.value_domain[index].nilai? true : null)"
                                        >
                                        </b-form-input>
                                        <b-form-invalid-feedback :state="false">{{ errors[0] }}</b-form-invalid-feedback>
                                      </ValidationProvider>
                                    </td>
                                    <td class="d-flex align-items-center flex-column">
                                      <b-button  class="button button--action button--action--delete2"  @click="data.value_domain.splice(index,1)" >
                                        <VueFeather type="x" size="14" stroke-width="2" style="display:block;"></VueFeather>
                                      </b-button>
                                    </td>
                                  </tr>
                                </tbody>
                                <tbody v-if="data.value_domain.length==0">
                                  <tr>
                                    <td :colspan="route == 'ViewMsVar' ? 3 : 4">
                                      <div class="table__empty">
                                        <VueFeather type="alert-circle" size="18"></VueFeather> &nbsp;
                                        Isian Klasifikas belum ada yang diinput
                                      </div>
                                    </td>
                                  </tr>
                                </tbody>
                              </b-table-simple>
                              <div class="pagination-wrapper d-block" style="padding: 7px 9px" v-if="data.id_sds == null && (route != 'ViewMsVar' && route != 'ApproveMsVar')">
                                <div class="d-flex align-items-center">
                                  <div class="flex-grow-1 text-600 text-13">
                                    Jika Isian Klasifikasi Lebih dari satu bisa melakukan klik tombol tambah
                                  </div>
                                  <b-button class="button button--action button--action--view2" 
                                    @click="()=>{
                                      validate().then(result =>{
                                        if(result){
                                          data.value_domain.push({kode: null,nilai: null});
                                        }
                                      })}">
                                    <VueFeather type="plus" size="14" stroke-width="2" style="display:block;"></VueFeather>
                                  </b-button>
                                </div>
                              </div>
                            </div>
                          </ValidationObserver>
                        </div>
                      </div>
                        

                      <div class="question">
                        <div class="question__name">Aturan Validasi:</div>
                        <div class="question__value" v-if="route == 'ViewMsVar' || route == 'ApproveMsVar'">
                          <div v-for="(item, index) in data.aturan_validasi" :key="index" class="d-flex">
                            <div class="w-15" v-if="data.aturan_validasi && data.aturan_validasi.length>1">{{index+1}}.</div>
                            <div>{{item}}</div>
                          </div>
                          <div v-if="data.aturan_validasi.length==0">-</div>
                        </div>
                        <div class="question__value" v-else>
                          <ValidationObserver ref="ruleVariableObserver" v-slot="{ validate }">
                            <div v-for="(item, index) in data.aturan_validasi" :key="index" >
                              <ValidationProvider :name="'Referensi Pemilihan ke-'+(index+1)"  rules="required" v-slot="{errors}">
                                <div class="d-flex">
                                  <b-form-input 
                                    v-model="data.aturan_validasi[index]" 
                                    placeholder="Tuliskan Referensi Pemilihan"
                                    :state="errors[0] ? false: (data.aturan_validasi[index] ? true : null)"
                                  >
                                  </b-form-input>
                                  <b-button  class="button button--action button--action--delete2 ml-2" style="margin-top:3px"  @click="data.aturan_validasi.splice(index,1)" >
                                    <VueFeather type="x" size="14" stroke-width="2" style="display:block;"></VueFeather>
                                  </b-button>
                                </div>
                                <b-form-invalid-feedback :state="false">{{ errors[0] }}</b-form-invalid-feedback>
                                <div class="d-flex mt-2" v-if="index==data.aturan_validasi.length-1">
                                  <div class="flex-grow-1 text-600">
                                    Jika Aturan Validasi Lebih dari satu bisa melakukan klik tombol tambah
                                  </div>
                                  <b-button  class="button button--action button--action--view2 " 
                                    @click="()=>{
                                      validate().then(result =>{
                                        if(result){
                                          data.aturan_validasi.push(null);
                                        }
                                      })}">
                                    <VueFeather type="plus" size="14" stroke-width="2" style="display:block;"></VueFeather>
                                  </b-button>
                                </div>
                                
                              </ValidationProvider>
                            </div>
                          </ValidationObserver>
                        </div>
                      </div>

                      <div class="question">
                        <div class="question__name">Kalimat Pertanyaan:</div>
                        <div class="question__value" v-if="route == 'ViewMsVar' || route == 'ApproveMsVar'">{{data.kalimat_pertanyaan || '-'}}</div>
                        <div class="question__value" v-else>
                          <ValidationProvider name="Kalimat Pertanyaan"  rules="required" v-slot="{errors}">
                            <b-form-input 
                              v-model="data.kalimat_pertanyaan" 
                              placeholder="Tulisakan Kalimat Pertanyaan"
                              :state="errors[0] ? false: (data.kalimat_pertanyaan ? true : null)"
                            >
                            </b-form-input>
                            <b-form-invalid-feedback :state="false">{{ errors[0] }}</b-form-invalid-feedback>
                          </ValidationProvider>
                        </div>
                      </div>

                      <div class="question">
                          <div class="question__name">Apakah variabel Dapat Diakses Umum?</div>
                          <div class="question__value" v-if="route == 'ViewMsVar' || route == 'ApproveMsVar'">{{data.apakah_variabel_bisa_diakses_umum ? 'Ya' : 'Tidak'}}</div>
                          <div class="question__value" v-else>
                          <b-form-radio-group v-model="data.apakah_variabel_bisa_diakses_umum" :options="options.ya_tidak.map(x=>({text:x.label,value:x.id}))"></b-form-radio-group>
                          </div>
                        </div>


                    </div>
                  </div>
                </ValidationObserver>

                

                
              </div>
              <!-- <div class="questionnaire__footer">
                <button class="button" variant="outlined" size="sm" @click="prev" v-if="section.currentIndex != null">
                  <VueFeather type="arrow-left-circle" size="16" stroke-width="2" style="display:block"></VueFeather>
                  &nbsp;&nbsp;Sebelumnya
                </button>
                <button class="button ml-auto" variant="primary" size="sm" @click="next" v-if="section.currentIndex!=section.items.length-1">
                  Selanjutnya&nbsp;&nbsp;
                  <VueFeather type="arrow-right-circle" size="16" stroke-width="2" style="display:block"></VueFeather>
                </button>
              </div> -->
            </div>
          </b-col>
          <b-col id="review" cols="4" class="pr-0 mr-0" v-if="isReviewVisible">
            <div class="sidebar-cards-wrapper" style="position: sticky; top: 157px; max-height: calc(100vh - 175px); overflow-y: auto; padding-right: 2px;">
              
              <!-- CARD 1: Catatan Pemeriksaan -->
              <div class="review my-0 mx-0 mb-3" style="position: relative; top: 0; height: auto; min-height: unset; margin: 0 0 16px 0 !important;"> 
                <div class="review__header" style="cursor: pointer;" @click="isReviewCardOpen = !isReviewCardOpen">
                  <div class="review__header__icon"> 
                    <VueFeather type="mail" size="16" stroke-width="2" style="display:block"></VueFeather>
                  </div>
                  <div class="review__header__title">
                    Catatan Pemeriksaan
                    <span v-if="(form.reviews && form.reviews.length > 0) || (reviewHistories && reviewHistories.length > 0)" class="badge badge-light ml-1 text-primary">
                      {{ (form.reviews ? form.reviews.length : 0) + (reviewHistories ? reviewHistories.length : 0) }}
                    </span>
                  </div>
                  <div class="review__header__close ml-auto d-flex align-items-center">
                    <button 
                      class="button mr-1" 
                      variant="icon" 
                      size="sm" 
                      @click.stop="isReviewCardOpen = !isReviewCardOpen"
                      :title="isReviewCardOpen ? 'Sembunyikan Catatan Pemeriksaan' : 'Tampilkan Catatan Pemeriksaan'"
                    >
                      <VueFeather :type="isReviewCardOpen ? 'chevron-up' : 'chevron-down'" size="16" stroke-width="2" style="display:block"></VueFeather>
                    </button>
                    <button class="button" variant="icon" size="sm" @click.stop="isReviewOpen = false" title="Tutup Panel">
                      <VueFeather type="x" size="16" stroke-width="2" style="display:block"></VueFeather>
                    </button>
                  </div>
                </div>

                <b-collapse v-model="isReviewCardOpen">
                  <div class="review__body" style="overflow-y:auto; max-height: 380px;">
                    <div style="margin-bottom:20px;" v-if="form.reviews && form.reviews.length>0" >
                        <div v-for="(reviewItem, reviewIndex) in form.reviews" :key="reviewIndex" class="review-item d-block">
                          <div class="d-flex">
                              <div class="review-item__number">{{reviewIndex+1}}.</div>
                              <div class="review-item__note">
                                <span class="review-item__field" v-if="reviewItem.field">
                                  #{{ reviewItem.field }} : 
                                </span>
                                {{reviewItem.note}}
                              </div>
                          </div>
                          <div class="d-flex align-items-center review-item__info pt-1 mb-1" style="padding-left:19px">
                              <div class="text-10 text-500 mr-2" style="line-height:1" v-if="reviewItem.created_at">{{reviewItem.created_at | formatDate}}</div>
                              <div class="text-10 text-500 mr-2" style="line-height:1" v-else-if="msVar">{{msVar.created_at | formatDate}}</div>
                              <div class="ml-auto" v-if="route == 'UpdateMsVar' || route == 'ApproveMsVar'">
                                <b-button  
                                    class="button button--action button--action--delete" 
                                    style="height:20px;width:20px!important;min-width:20px!important" 
                                    v-b-tooltip.hover title="Hapus Catatan"
                                    @click="form.reviews.splice(reviewIndex, 1)"
                                >
                                    <VueFeather type="x" size="12"></VueFeather>
                                </b-button>
                              </div>
                          </div>
                        </div>
                    </div>
                    <div class="history-review" v-if="msVar" >
                        <div class="text-bold text-primary" style="margin:5px 11px">History Pemeriksaan:</div>
                        <div v-if="reviewHistories && reviewHistories.length==0" class="" style="margin-top:-5px;margin-left:11px"> Belum ada history yang tersedia</div>
                        <div v-else class="mt-1">
                          <div v-for="(reviewItem, reviewIndex) in reviewHistories" :key="reviewIndex" class="review-item d-block">
                              <div class="d-flex">
                                  <div class="review-item__number">{{reviewIndex+1}}.</div>
                                  <div class="review-item__note">
                                    <span class="review-item__field" v-if="reviewItem.field">
                                      #{{ reviewItem.field }} : 
                                    </span>
                                    {{reviewItem.note}}
                                  </div>
                              </div>
                              <div class="d-flex align-items-center review-item__info pt-1" style="padding-left:19px" v-if="reviewItem.created_at">
                                  <div class="text-10 text-500 mr-2" style="line-height:1">{{reviewItem.created_at | formatDate}}</div>
                              </div>
                          </div>
                        </div>
                    </div>
                  </div>

                  <div class="review__footer form form-sm mt-auto" v-if="route == 'UpdateMsVar' || route == 'ApproveMsVar'">
                    <Treeselect  
                      placeholder="Pilih attribute agar cakupan review lebih jelas"
                      v-model="review.field" 
                      :options="Object.keys(data).filter(x=>x!='id_sds').map(x=>({id:x.replace('_','-'), label: capitalize(x.replace('_',' '))}))" 
                      :disable-branch-nodes="true" 
                      :clearable="true" 
                      class="small-container"
                      :loadOptions="loadOptions">
                    </Treeselect>
                    <b-form-textarea 
                      class="mt-1 text-13"
                      rows="3"
                      v-model="review.note" 
                      placeholder="Tuliskan catatan pemeriksaan..." 
                    >
                    </b-form-textarea>
                    <div class="d-flex justify-content-end mt-2">
                      <button 
                        class="button" 
                        variant="primary" 
                        size="sm" 
                        :disabled="!review.note || !review.note.trim()"
                        @click="()=>{
                          form.reviews.push({
                            field: review.field,
                            note: review.note.trim(),
                            created_at: now,
                          });
                          review = { field: null, note: null };
                        }"
                      >
                        <VueFeather type="plus" size="14" stroke-width="2"></VueFeather>&nbsp; Tambah Catatan
                      </button>
                    </div>
                  </div>
                </b-collapse>
              </div>

              <!-- CARD 2: Histori Status -->
              <div class="review my-0 mx-0" style="position: relative; top: 0; height: auto; min-height: unset; margin: 0 0 16px 0 !important;" v-if="msVar && msVarHistories && msVarHistories.length>0">
                <div class="review__header" style="cursor: pointer;" @click="isHistoryStatusCardOpen = !isHistoryStatusCardOpen">
                  <div class="review__header__icon"> 
                    <VueFeather type="clock" size="16" stroke-width="2" style="display:block"></VueFeather>
                  </div>
                  <div class="review__header__title">
                    Histori Status
                    <span class="badge badge-light ml-1 text-primary">
                      {{ msVarHistories.length }}
                    </span>
                  </div>
                  <div class="review__header__close ml-auto d-flex align-items-center">
                    <button 
                      class="button" 
                      variant="icon" 
                      size="sm" 
                      @click.stop="isHistoryStatusCardOpen = !isHistoryStatusCardOpen"
                      :title="isHistoryStatusCardOpen ? 'Sembunyikan Histori Status' : 'Tampilkan Histori Status'"
                    >
                      <VueFeather :type="isHistoryStatusCardOpen ? 'chevron-up' : 'chevron-down'" size="16" stroke-width="2" style="display:block"></VueFeather>
                    </button>
                  </div>
                </div>

                <b-collapse v-model="isHistoryStatusCardOpen">
                  <div class="review__body" style="overflow-y:auto; max-height: 380px; padding: 10px 12px;">
                    <div class="history-status mt-0" style="margin: 0px 0px;">
                      <div v-for="(history, historyIndex) in msVarHistories" :key="historyIndex" class="history-status__item">
                          <div class="d-flex align-items-center">
                              <div class="history-status__number">{{historyIndex+1}}.</div>
                              <div :class="'history-status__badge history-status__badge--'+ statusFormatterStyle(history.status)">
                                  {{statusFormatter(history.status)}}
                              </div>
                              <div class="text-10 text-500 ml-auto" v-if="history.created_at" style="line-height:1">
                                  {{history.created_at | formatDate}}
                              </div>
                          </div>
                          <div class="history-status__info" v-if="history.created_by && history.created_by.organization && history.created_by.organization.name">
                              <span>{{history.created_by.organization.name}}</span>
                          </div>
                          <div class="history-status__rejection" v-if="history.status == 'REJECTED' && history.rejection_note">
                              <strong>Catatan Penolakan:</strong> {{history.rejection_note}}
                          </div>
                      </div>
                    </div>
                  </div>
                </b-collapse>
              </div>

            </div>
          </b-col>
        </b-row>
        
      </div>
      
    </div>
    <b-modal hide-header hide-footer id="modal-error" size="sm" content-class="modal--error text-center mt-5" dialog-class="d-flex justify-content-center">
      <div>
        <div class="text-center py-5 px-2" style="color:red">
          <div class="mb-3 d-flex justify-content-center align-item-center">
            <div class="border mx-4 " style="border-color:#F48FB1 !important;width:40%">
              <div style="position:relative;background-color:#FCE4EC;height:20px;border-color:#F48FB1 !important" class="border-bottom mb-2" >
                <div style="position:absolute;top:-10px;right:-10px"><VueFeather type="x-circle" size="20" stroke-width="1.5" fill="#FCE4EC"></VueFeather></div>
              </div>
              <div class="px-3 py-2" style="">
                <b-skeleton animation width="85%" height="10px" style="background-color:#fff1f6;border:1px solid #F8BBD0;margin-bottom:10px"></b-skeleton>
                <b-skeleton animation width="55%" height="10px"></b-skeleton>
                <b-skeleton animation width="70%" height="10px"></b-skeleton>
                <b-skeleton animation width="100%" height="10px"></b-skeleton>
              </div>
            </div>
          </div>
          <div style="font-weight:600;font-size:17px;color:red">
            {{modal.error.title}} 
          </div>
          <!-- <div style="font-weight:500;font-size:13px;color:#616161;word-break: break-word;" v-html="modal.error.description"> -->
            <!-- {{modal.error.description}}  -->
          <!-- </div> -->
          <div class="mt-3">
            <b-button 
              class="i-button"
              style="color:white !important;background-color:#2e2e2e !important;padding:3px 10px;border-radius:3px !important; font-weight:600" 
              v-on:click="()=>{$bvModal.hide('modal-error');}">OK</b-button>
          </div>
        </div>
      </div>
    </b-modal>
    <b-modal hide-header hide-footer size="sm" id="modal-loading"  content-class="modal modal--confirmation text-center p-2" centered dialog-class="d-flex justify-content-center">
      <div class="text-center px-3 py-4">
        <img src="@/assets/img/loader.gif" width="100" height="100" />
        <div style="font-weight:600;font-size:16px;color:#01ad85">
          Mohon tunggu sebentar 
        </div>
        <div style="font-weight:500;font-size:13px;color:#0a4e5c;">
          Proses pengecekan Rekomendasi sedang berlangsung
        </div>
      </div>
    </b-modal>
    <b-modal  hide-header hide-footer id="modal-saving" size="sm" content-class="modal modal--error text-center p-2" centered dialog-class="d-flex justify-content-center">
      <div v-if="saveState=='SAVING'">
        <div class="text-center py-3">
          <img src="@/assets/img/loader.gif" width="100" height="100" />
          <div style="font-weight:600;font-size:16px;color:#01ad85">
            Mohon tunggu sebentar 
          </div>
          <div style="font-weight:500;font-size:13px;color:#0a4e5c;">
            Proses menyimpan sedang berlangsung 
          </div>
        </div>
      </div>
      <div v-if="saveState=='SUCCESS'">
        <div class="text-center py-3">
          <img src="@/assets/img/success.gif" width="100" height="100" />
          <div style="font-weight:600;font-size:16px;color:#01ad85">
            Berhasil menyimpan 
          </div>
          <div style="font-weight:500;font-size:13px;color:#0a4e5c;">
            Anda akan di <i>redirect</i> ke halaman approval dalam beberapa detik
          </div>
        </div>
      </div>
      <div v-if="saveState=='ERROR'">
        <div class="text-center py-3" style="color:red">
          <div >
            <VueFeather type="x-circle" size="50" stroke-width="1"></VueFeather>
          </div>
          <div style="font-weight:600;font-size:17px;color:red">
            Error 
          </div>
          <div style="font-weight:600;font-size:13px;color:#0a4e5c;font-family:'Open Sans'">
            {{saveError}} 
          </div>
          <div class="mt-3 d-flex justify-content-center">
            <b-button 
              class="button button--warning"
              v-on:click="()=>{$bvModal.hide('modal-saving');}">Kembali</b-button>
          </div>
        </div>
      </div>
    </b-modal>

    <b-modal hide-header hide-footer size="md" id="modal-approval" modal-class="modal modal--warning">
      <ValidationObserver ref="saveSubmissionObserver" v-slot="{validate}">
        <div class="modal__header border-bottom-0 ">
          <div class="modal__header__icon">
            <VueFeather type="send" size="22" stroke-width="2"></VueFeather>
          </div>
          <div class="modal__header__title">
            <div class="modal__header__title__name"> 
              Simpan Pemeriksaan 
            </div>
            <div class="modal__header__title__description" style="font-weight:500;letter-spacing:0px"> 
              Pastikan pemeriksaan sudah sesuai sebelum mengirim data ke server
            </div>
          </div>
          <div class="modal__header__close">
            <button  class="button button--action button--outlined" @click="$bvModal.hide('modal-approval')">
              <VueFeather type="x" size="14" stroke-width="2"></VueFeather>
            </button>
          </div>
        </div>
        <div class="modal__body">
          <div class="form text-medium" style="border-radius:4px">
            
              <b-form-group label="Status Usulan">
                <Treeselect  
                  :clearable="false" 
                  v-model="form.status" 
                  :options="options.status.filter(x=>x.id != 'REVISED')" :disable-branch-nodes="true" 
                  :loadOptions="loadOptions" class="valid"
                  
                >
                </Treeselect>
              </b-form-group>


              <ValidationProvider immediate name="Jenis penolakan"  rules="required" v-slot="{errors}" v-if="form.status == 'REJECTED'">
                <b-form-group label="Jenis penolakan">
                  <Treeselect 
                    :clearable="false"
                    placeholder="Pilih jenis alasan penolakan"
                    v-model="rejectionNote.type"
                    :class="errors[0] ? 'invalid': ( rejectionNote.type ? 'valid' : null)"
                    :options="options.rejected_status_type"
                    :loadOptions="loadOptions"
                  />
                  
                  <b-form-invalid-feedback :state="false">{{ errors[0] }}</b-form-invalid-feedback>
                </b-form-group>
              
              </ValidationProvider>

              <ValidationProvider immediate name="Catatan"  v-if="rejectionNote.type == 'OTHER' && form.status == 'REJECTED'"  rules="required" v-slot="{errors}">
                <b-form-group label="Catatan">
                  <b-form-textarea 
                    rows="3"
                    v-model="rejectionNote.note" 
                    placeholder="Tuliskan secara jelas deskripsi ukuran" 
                    :state="errors[0] ? false: ( rejectionNote.note ? true : null)"
                  >
                  </b-form-textarea>
                  <b-form-invalid-feedback :state="false">{{ errors[0] }}</b-form-invalid-feedback>
                </b-form-group>
              </ValidationProvider>
            
          </div>
        </div>
        <div class="modal__footer">
          <div class="d-flex ml-auto mx-1">
            <button type="button" class="button " variant="outlined" @click="$bvModal.hide('modal-approval')">Batal</button>
            <button type="button" class="button ml-2" variant="warning" @click="()=>{
              validate().then(result=>{
                if(result){
                  sendData();
                }
              })  
            }">Kirim</button>
          </div>
        </div>
      </ValidationObserver>
    </b-modal>

    
  </div>
  
</template>

<script>
import "@/assets/scss/main.scss";
import Treeselect from '@riophae/vue-treeselect';
import '@riophae/vue-treeselect/dist/vue-treeselect.css';
import moment from 'moment';
import { ValidationObserver, ValidationProvider } from "vee-validate";
import VueFeather from 'vue-feather';
import Multiselect from 'vue-multiselect';
import 'vue-multiselect/dist/vue-multiselect.min.css';
import "vue-select/dist/vue-select.css";
import MsService from "../../../services/MsService";
import SdsService from "../../../services/SdsService";
import store from "../../../store";
export default {
  components: {
    VueFeather,
    ValidationObserver,
    ValidationProvider,
    Multiselect,
    Treeselect,
  },
  data: () => ({
    route:null,
    baseId:null,
    updatedId:null,
    user:null,
    userRoles:[],
    isLoading:false,
    isSdsLoading:false,
    saveState:'SUCCESS',
    saveError:null,
    rejectionNote:{
        type:null,
        note:null,
      },
    msKeg:null,
    msVar:null,
    sdsVariable:null,
    sds:null,
    showSdsRedirectNotif:null,
    formExt:{
      getRecommendation:false,
      produsenData:null,
      wilayah:null,
      
    },
    form:{
      ms_keg_id: null,
      submission_period: null,
      data: null,
      reviews: [],
      changes: [],
      status: "DRAFT",
      rejection_note: null,
      submitter: null,
      produsen_data: null,
      walidata_pusat: null,
      version: 'v2'
    },
    data: {
      nama: null,
      alias: null,
      definisi: null,
      konsep: [null],
      referensi_pemilihan: [
        null
      ],
      referensi_waktu: null,
      ukuran: null,
      satuan: null,
      tipe_data: null,
      value_domain: [
        {
          kode: null,
          nilai: null
        }
      ],
      aturan_validasi: [
        null
      ],
      kalimat_pertanyaan: null,
      apakah_variabel_bisa_diakses_umum: true,
      id_sds: null,
    },
    review:{
      field:null,
      note:null,
    },
    isReviewOpen: true,
    isReviewCardOpen: true,
    isHistoryStatusCardOpen: true,
    options:{
      rejected_status_type :[
          {id:'IMPROPERLY_REQUEST', label:'Laporan Metadata tidak layak'},
          {id:'REQUESTED_BY_USER', label:'Diminta oleh pelapor'},
          {id:'OTHER', label:'Lainnya'},
        ],
      value_domain_type:[
          { value: { id: 75, name: 'Described Value Domain', description:'Jenis value domain yang nilai dinyatakan dalam bentuk ekspresi atau deskripsi' }, text: 'Non Kategori',},
          { value: { id: 76, name: 'Enumerated Value Domain', description: 'Jenis value domain yang nilai dinyatakan sebagai daftar kode dan kategori' }, text: 'Kategori' },
        ],
      status:[
        { id: "DRAFT", label: "Draft" },
        { id: "SUBMITTED", label: "Submit" },
        { id: "UNDER_REVIEW", label: "Sedang Diperiksa" },
        { id: "REVISED", label: "Sudah Diperbaiki" },
        { id: "CORRECTION_REQUIRED", label: "Perlu Perbaikan" },
        { id: "REJECTED", label: "Ditolak" },
        { id: "APPROVED", label: "Disetujui" },
        // { id: "PUBLISHED", label: "Publis" }
      ],
      sdsStatus:[
          {value:'DRAFT_KABKOTA', label:'Draft Produsen Data Kabupaten/Kota'},
          {value:'SUBMITTED_KABKOTA', label:'Submit Produsen Data Kabupaten/Kota'},
          {value:'REVIEW_KABKOTA', label:'Diperiksa Walidata Kabupaten/Kota'},
          {value:'CORRECTION_KABKOTA', label:'Perbaikan Produsen Data & Walidata Kabupaten/Kota'},
          {value:'PENDING_KABKOTA', label:'Ditunda Walidata Kabupaten/Kota'},
          {value:'REJECTED_KABKOTA', label:'Ditolak Walidata Kabupaten/Kota'},
          {value:'APPROVED_KABKOTA', label:'Diterima Walidata Kabupaten/Kota'},

          {value:'DRAFT_PROVINSI', label:'Draft Produsen Data Provinsi'},
          {value:'SUBMITTED_PROVINSI', label:'Submit Produsen Data Provinsi'},
          {value:'REVIEW_PROVINSI', label:'Diperiksa Walidata Provinsi'},
          {value:'CORRECTION_PROVINSI', label:'Perbaikan Produsen Data & Walidata Provinsi'},
          {value:'REJECTED_PROVINSI', label:'Ditolak Walidata Provinsi'},
          {value:'APPROVED_PROVINSI', label:'Diterima Walidata Provinsi'},
          {value:'PENDING_PROVINSI', label:'Ditunda Walidata Provinsi'},

          {value:'DRAFT_PUSAT', label:'Draft Produsen Data Pusat'},
          {value:'SUBMITTED_PUSAT', label:'Submit Produsen Data Pusat'},
          {value:'REVIEW_PUSAT', label:'Diperiksa Walidata Pusat'},
          {value:'CORRECTION_PUSAT', label:'Perbaikan Produsen Data & Walidata Pusat'},
          {value:'REJECTED_PUSAT', label:'Ditolak Walidata Pusat'},
          {value:'APPROVED_PUSAT', label:'Diterima Walidata Pusat'},
          {value:'PENDING_PUSAT', label:'Ditunda Walidata Pusat'},
          {value:'PUBLISHED_PUSAT', label:'Publish'},
        ],
      ya_tidak: [
        {id:true , label:'Ya', code:1},
        {id:false , label:'Tidak', code:2},
      ],
      sds:[]
    },
    modal:{
      error:{
        title:null,
        description:null,
      }
    }
  }),
  watch:{
  },
  computed:{
    isReviewVisible() {
      if (!this.isReviewOpen) return false;
      return (
        this.route === 'UpdateMsVar' ||
        this.route === 'ApproveMsVar' ||
        this.form.status === 'CORRECTION_REQUIRED' ||
        (this.form.reviews && this.form.reviews.length > 0) ||
        (this.reviewHistories && this.reviewHistories.length > 0) ||
        (this.msVarHistories && this.msVarHistories.length > 0)
      );
    },
    now(){
      return moment().format('YYYY-MM-DD HH:mm:ss.SSS')
    },
    reviewHistories(){
      let msVar = this.msVar;
      let showedReviews = [];
      if(msVar){
        let allReview = msVar.ms_var_histories.filter(x=> !x.active && x.reviews && x.reviews.length>0).map(x=>x.reviews).flat();
        let currentReviewNotes = msVar.reviews ? msVar.reviews.map(x=>x.note) : [];

        allReview.forEach(x=>{
          if(!currentReviewNotes.includes(x.note)){
            showedReviews.push(x);
          }
        })
      }
      
      
      return showedReviews;
    },
    msVarHistories(){
      const msVar = this.msVar;
      if(!msVar || !Array.isArray(msVar.ms_var_histories)){
        return [];
      }
      // Sort dari yang terbaru ke yang terlama
      return [...msVar.ms_var_histories].sort((a, b) => {
        const ta = a.created_at ? new Date(a.created_at).getTime() : 0;
        const tb = b.created_at ? new Date(b.created_at).getTime() : 0;
        return tb - ta;
      });
    }
  },
  async mounted() {
    this.route = this.$route.name;
    this.getUserInfo(store.getters["auth/user"]);
    if(this.route == "AddMsVar"){
      this.getDetailMsKeg(this.$route.params.id)
    }
    if (this.route == "ViewMsVar" || this.route == 'UpdateMsVar' || this.route == 'ApproveMsVar' ) {
      let id = parseInt(this.$route.params.id);
      this.updatedId = id;

      this.isLoading = true;
      await this.getDetailMsVar(id);
      this.isLoading = false;
    }
  },
  
  methods: {
    getUserInfo(user){
      this.user = {
        username: user.username,
        name : user.name,
        email: user.email,
        organization: {
          id: user.sdiOrganization.id,
          name: user.sdiOrganization.name,
          address: user.sdiOrganization.details.address,
          province: user.sdiOrganization.details.province,
          city: user.sdiOrganization.details.city,
        } 
      }
      this.userRoles = user.role.slice(1,-1).split(", ");
      this.form.submitter = this.user;
    },
    async getSdsList(searchQuery){
      let query = "name="+searchQuery+'&sdsType=VARIABLE&page=0&size=20&status=APPROVED_PUSAT';
      this.isSdsLoading = true;
      await SdsService.getSdsItemListByQuery(query).then(
        (result)=>{
          let response = result.data;
          this.options.sds = response.content.filter(x=>!x.status.includes('DRAFT') && !x.status.includes('REJECTED'));
        },
        (error)=>{
          console.log(error)
        }
      )
      this.isSdsLoading = false;
    },
    async getDetailMsKeg(id){
      await MsService.getMsKegById(id).then(
        response => {
          this.msKeg = response.data.result[0];
          this.form.ms_keg_id = parseInt(id);
          this.form.submission_period = this.msKeg.submission_period;
          this.form.produsen_data = this.msKeg.produsen_data;
          this.form.produsen_data = this.msKeg.produsen_data;
          this.form.submitter= this.user;
          this.form.produsen_data={
            id: this.msKeg.produsen_data_id,
            name: this.msKeg.produsen_data_name,
            province_code: this.msKeg.produsen_data_province_code,
            city_code: this.msKeg.produsen_data_city_code
          };
          this.form.walidata_pusat= {
            id: this.msKeg.walidata_pusat_id,
            name: this.msKeg.walidata_pusat_name
          }
        },
        error => {
          console.error(error);
        }
      );
    },
    async getDetailMsVar(id){
      await MsService.getMsVarById(id).then(
        response => {
          this.msVar = response.data.result[0];
          this.data = this.msVar.data;
          this.form.status = this.msVar.status,
          this.form.reviews = this.msVar.reviews ? this.msVar.reviews : [];
          this.form.ms_keg_id = this.msVar.ms_keg_id;
          this.form.submission_period = this.msVar.submission_period;
          this.form.produsen_data = this.msVar.produsen_data;
          this.form.submitter= this.user;
          this.form.produsen_data={
            id: this.msVar.produsen_data_id,
            name: this.msVar.produsen_data_name,
            province_code: this.msVar.produsen_data_province_code,
            city_code: this.msVar.produsen_data_city_code
          };
          this.form.walidata_pusat= {
            id: this.msVar.walidata_pusat_id,
            name: this.msVar.walidata_pusat_name
          }
          if(this.route == 'ApproveMsVar'){
            this.form.status = this.msVar.status == 'SUBMITTED' || this.msVar.status == 'REVISED' ? 'UNDER_REVIEW' : this.msVar.status;
          }else{
            this.form.status = this.msVar.status;
          }
          
          let variable = this.msVar.data;
          if(this.msVar.version == 'v1'){
            this.data= {
              nama: variable.nama,
              alias: variable.alias,
              konsep: variable.konsep ? [variable.konsep] : [null],
              definisi: variable.definisi,
              referensi_pemilihan: variable.referensiPemilihan && variable.referensiPemilihan.length>0 ? variable.referensiPemilihan.map(x=>x.nama) : [],
              referensi_waktu: variable.referensiWaktu,
              ukuran: variable.ukuran,
              satuan: variable.satuan,
              tipe_data: variable.tipeData,
              value_domain: variable.valueDomain && variable.valueDomain.length>0 ? variable.valueDomain : [],
              aturan_validasi: variable.aturanValidasi && variable.aturanValidasi.length>0 ? variable.aturanValidasi : [null],
              kalimat_pertanyaan: variable.kalimatPertanyaan,
              apakah_variabel_bisa_diakses_umum: variable.apakahVariabelBisaDiaksesUmum,
              id_sds: null,
            };
          }
          //fix error was caused sds
          if(this.data.value_domain==null){
            this.data.value_domain = []
          }
          this.sds = {
            id: variable.nama,
            name: variable.nama,
          }
        },
        error => {
          console.error(error);
        }
      );
    },
    async validateAll(){
      return await this.$refs.blok1Observer.validate();
    },
    async save(saveType) {
      let valid = await this.validateAll();
      this.form.data = this.data;
      if(saveType == 'DRAFT'){
        let minValid = true;
        if(this.form.data.nama == null){
          minValid = false;
          this.modal.error.description = 'Untuk dapat menyimpan dalam bentuk DRAFT, <span class="text-primary">Nama Variabel</span> tidak boleh kosong';
        }

        if(minValid){
          this.sendData()
        }else{
          this.modal.error.title = 'Isian Error';
          this.$bvModal.show('modal-error');
        }
      }else{
        if(valid){
          this.form.status=this.form.status == 'DRAFT' ? 'SUBMITTED' : 'REVISED'; 
          this.sendData()
        }else{
          this.modal.error.title = 'Isian Error';
          this.modal.error.description = 'Untuk dapat melakukan submit, pastikan tidak ada lagi isian yang error';
          this.$bvModal.show('modal-error');
        }
      }
    },
    async sendData(){
      this.$bvModal.show('modal-saving');
      this.saveState = 'SAVING';
      this.form.data = this.data;
      if(this.form.status == 'REJECTED'){
        this.form.rejection_note = this.rejectionNote;
      }

      if(this.route == "UpdateMsVar" || this.route == "ApproveMsVar"){
        MsService.updateMsVar(this.form,this.updatedId).then(
          (result) => {
            let response = result.data.result[0];
            if(response.status == 403 || response.status == 500){
              if(response.status == 403){
                this.modal.error.title = 'Forbidden';
                this.modal.error.description = 'Anda tidak mempunyai akses untuk mengupdate item';
              }
              else{
                this.modal.error.title = response.title;
                this.modal.error.description = response.detail;
              }
              this.$bvModal.hide('modal-saving');
              this.$bvModal.show('modal-error');
            }else{
              this.saveState = 'SUCCESS';
              if(this.route == "UpdateMsVar" ){
                this.delay(2000).then(() => this.$router.push('/metadata/view-kegiatan/'+this.form.ms_keg_id));
              }else{
                this.delay(2000).then(() => this.$router.push('/metadata/pemeriksaan/kegiatan/'+this.form.ms_keg_id));
              }
            }
          },
          (error) => {
            this.saveState = 'ERROR';
            this.saveError = error.response;
          }
        );
      }else{
        MsService.saveNewMsVar(this.form).then(
          (result) => {
            let response = result.data.result[0];
            if(response.status == 403 || response.status == 500){
              if(response.status == 403){
                this.modal.error.title = 'Forbidden';
                this.modal.error.description = 'Anda tidak mempunyai akses untuk menambahkan item';
              }
              else{
                this.modal.error.title = response.title;
                this.modal.error.description = response.detail;
              }
              this.$bvModal.hide('modal-saving');
              this.$bvModal.show('modal-error');
            }else{
              this.saveState = 'SUCCESS';
              this.delay(2000).then(() => this.$router.push('/metadata/view-kegiatan/'+this.form.ms_keg_id));
            }
          },
          (error) => {
            this.saveState = 'ERROR';
            this.saveError = error.response;
          }
        );
      }
      
    },
    capitalize(sentence){
      return sentence ? sentence.replaceAll('_',' ').toLowerCase().replace(/(^\w{1})|(\s+\w{1})/g, letter => letter.toUpperCase()) : '-';
    },
    statusFormatterStyle(status){
      return status ? status.toLowerCase().replace('_','-') : 'draft';
    },
    statusFormatter(status){
      let stat = this.options.status.find(x=>x.id == status)
      return stat ? stat.label : 'Draft';
    },
    sdsStatusFormatter(status){
      let stat = this.options.sdsStatus.find(x=>x.value == status)
      return stat ? stat.label : 'Draft';
    },
    changeQuesModeValue(att){
      this.ques[att] = this.options[att].find(x=>x.id==this.data[att]).code
    },
    changeEntriModeValue(att){
      let value = this.options[att].find(x=>x.code==this.ques[att]);
      if(value){
        this.data[att] = value.id;
      }
    },
    loadOptions({callback}) {
      let result = 'Sedang melakukan load data'
      callback(null, result)
    },
    scrollToUpperMost: function() {
      setTimeout(function() {
        window.scrollTo({ top: 0, left: 0, behavior: "smooth" });
      }, 100);
    },
    delay(time) {
      return new Promise(resolve => setTimeout(resolve, time));
    },
    async useVariableSds(variable){
      this.showSdsRedirectNotif = false;
      if(variable){
        await SdsService.getSdsItem(variable.id).then(
          (result)=>{
            let x =  {...result.data.result[0]};
            this.sdsVariable = this.updateVariableStructure(x.data.variable);
            this.data.nama= this.sdsVariable.name;
            this.data.konsep= this.sdsVariable.concepts.length>0 ? this.sdsVariable.concepts.map(x=>x.name) : [null];
            this.data.definisi= this.sdsVariable.definition;
            this.data.referensi_pemilihan = this.sdsVariable.references &&  this.sdsVariable.references.length>0 ? this.sdsVariable.references : [null];
            this.data.ukuran= this.sdsVariable.measurement ? this.sdsVariable.measurement.name : null;
            this.data.satuan= this.sdsVariable.measurement_unit ? this.sdsVariable.measurement_unit.name : null;
            this.data.value_domain= this.sdsVariable.value_domain.items.length==0 ? [] :this.sdsVariable.value_domain.items.map(x=>({
              kode : x.code,
              nilai : x.name,
            })),
            this.data.id_sds= x.id;
          },
          (error)=>{
            console.log(error);
          }
        );
      }else{
        this.data.nama= null;
        this.data.konsep= null;
        this.data.konsep= [null];
        this.data.definisi= null;
        this.data.referensi_pemilihan = [null];
        this.data.ukuran= null;
        this.data.satuan= null;
        this.data.value_domain= [{
          kode : null,
          nilai :null,
        }];
        this.data.id_sds= null;
      }
      
    },
    inputVariableManual(variable){
      this.showSdsRedirectNotif = true;
      this.sds = {
        id : variable,
        name : variable
      }
      this.data.nama = variable;
      this.data.konsep= [null];
      this.data.definisi= null;
      this.data.referensi_pemilihan = [null];
      this.data.ukuran= null;
      this.data.satuan= null;
      this.data.value_domain= [{
        kode : null,
        nilai :null,
      }];
      this.data.id_sds= null;
    },
    updateVariableStructure(variable){
      let newVariable = {
        code: variable.code,
        name: variable.name,
        definition: variable.definition,
        concepts: ('concept' in variable) ? variable.concept : variable.concepts, //update with actual state,
        unit_types: variable.unit_types, //change format json
        measurement: variable.measurement, //change format json
        measurement_unit: variable.measurement_unit, //change format json,
        subject_field: variable.subject_field, //change format json,
        value_domain: variable.value_domain, //change format json
        rule: variable.rule,
        references: variable.references.map(x=>typeof x == 'string' ? x : x.name),
        updated_variable: null,
      }
      //change format json for unit types 
      if(newVariable.unit_types != null & newVariable.unit_types.length>0){
        newVariable.unit_types = newVariable.unit_types.filter(x=>x!=null).map(item => {
          if(item.id == null){
            let _newUnitTypes = {
              id:null,
              name:item.name,
              description:null,
            };
            return _newUnitTypes;
          }else{
            return item;
          }        
        });
      }
      //change format json for measurement 
      if(newVariable.measurement){
        if(newVariable.measurement.id == null){
          let newMeasurement = {
            id:null,
            name:newVariable.measurement.name,
            description:null,
          };
          newVariable.measurement = newMeasurement;
        }
      }
      //change format json for measurement unit
      if(newVariable.measurement_unit){
        if(newVariable.measurement_unit.id == null){
          let newMeasurementUnit = {
            id: null,
            name: newVariable.measurement_unit.name,
            symbol: null
          }
          newVariable.measurement_unit = newMeasurementUnit;
        }
      }
      if(newVariable.value_domain){
        let newValueDomain  = {
          type: null,// change use current format
          classification_reference: null,
          items:[],
          total_levels:0
        }
        if(newVariable.value_domain.type && newVariable.value_domain.type.id != null){
          newValueDomain.type = this.options.value_domain_type.map(x=> x.value).find(x => x.id == newVariable.value_domain.type.id);
          if(newValueDomain.type.id == 76){
            if('classification' in newVariable.value_domain){
              newValueDomain.classification_reference = newVariable.value_domain.classification.id ? {
                id: newVariable.value_domain.classification.id,
                name: newVariable.value_domain.classification.name,
                description: null,
                used_type: newVariable.value_domain.classification.items.length>0 ? 'PARTIAL' : 'FULL',
              } : null;
              newValueDomain.items = newVariable.value_domain.classification.items;
            }else{
              newValueDomain.classification_reference = newVariable.value_domain.classification_reference;
              newValueDomain.items = newVariable.value_domain.items;
            }
          }
        }
        newVariable.value_domain = newValueDomain;
      }
      return newVariable;
    },
    
  },
 
};
</script>
